<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-users"></i> {{ "TITLE.SIGNATORIES-REVIEWERS" | translate }}</h4>
  </div>
  <div class="modal-body">
    <div class="table-responsive">
      <table class="table-sm">
        <thead class="custom-font-size-table-header">
        <tr>
          <th scope="col" title="#"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.ACTION' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.PERSON' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.STATE' | translate }}"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let person of peopleReceived; let index = index">
          <td title="#" class="font-weight-bold">{{index + 1}}</td>
          <td title="{{'TABLE.HEADER.ENTERPRISE' | translate }}">{{person._more.enterpriseTradeNameView}}</td>
          <td title="{{'TABLE.HEADER.ACTION' | translate}}">
          <span class="badge {{isSigner(person)?'badge-primary':'badge-warning'}}">
           <i
             class="{{isSigner(person)? 'fas fa-signature': 'fas fa-eye'}}"></i> {{getOperationDescription(person) | translate}}
          </span>
          </td>
          <td title="{{'TABLE.HEADER.PERSON' | translate }}">{{person.fullname | translate}}</td>
          <td title="{{'TABLE.HEADER.STATE' | translate }}">
          <span
            class="badge {{isOperationComplete(person) ? 'badge-success': !isEnabledBySignature(person) ? 'custom-badge-modified' : 'custom-badge-attended'}}">
         <i class="{{!isOperationComplete(person)? 'fas fa-clock': 'fas fa-check'}}"></i>
            {{isOperationComplete(person) ? ("MESSAGE.COMPLETED" | translate) : !isEnabledBySignature(person) ? ("MESSAGE.NOT-COMPLETED" | translate) : getCurrentOperation(person) | translate}}
        </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" aria-label="Close"
            (click)="accept()">{{ "BUTTON.ACCEPT" | translate }}</button>
  </div>
</div>
